import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import apiInputService from "services/apiInputService";

type ResetPasswordPayload = {
  password: string;
  confirmPassword: string;
  token: string;
  realm: string;
};

const resetPassword = async (resetPasswordPayload: ResetPasswordPayload) => {
  return await axios.put("/users/resetPassword", resetPasswordPayload, {
    params: {
      realm: resetPasswordPayload.realm,
    },
    baseURL: process.env.REACT_APP_INPUT_CORE,
  });
};

export const useResetPassword = (options?: any) => {
  return useMutation(resetPassword, {
    ...options,
  });
};
